<template>
  <div class="vue-container" id="table-guest-exams">
    <div class="flex justify-between" style="flex-wrap: wrap">
      <div class="flex">
        <label class="radio inline flex">
          <input type="radio" v-model="search" name="search" :id="`start_null_${rand}`" value="2" class="search-exam" @change="change()" />
          <label :for="`start_null_${rand}`">{{ i18nJS.to_do }}</label>
        </label>
        <label class="radio inline flex">
          <input
            type="radio"
            v-model="search"
            name="search"
            :id="`start_not_null_${rand}`"
            value="3"
            class="search-exam"
            @change="change()"
          />
          <label :for="`start_not_null_${rand}`">{{ i18nJS.fatti }}</label>
        </label>
        <label class="radio inline flex">
          <input type="radio" v-model="search" name="search" :id="`all_${rand}`" value="4" class="search-exam" @change="change()" />
          <label :for="`all_${rand}`">{{ i18nJS.all }}</label>
        </label>
      </div>
      <div class="display-inline-flex align-items-baseline" style="margin-left: auto">
        <button
          v-if="!showFilter"
          class="fa-light fa-magnifying-glass pulsante_comando js-tooltip bg-white z-index-1 outline-none"
          title=""
          data-original-title="Cerca..."
          @click="toggleFilter()"
          type="button"
          style="margin-bottom: 11px"
        ></button>
        <transition name="menu-translate">
          <div v-if="showFilter" class="display-inline-flex align-items-baseline" style="align-items: end">
            <v-select2
              :value="filterParams.id"
              :element_id.sync="filterParams.id"
              :multiple="true"
              :data-allow-clear="false"
              :data-placeholder="i18nJS.prestazione"
              :data-ajax--url="getExamTypes"
              :data-minimumInputLength="2"
            >
            </v-select2>
            <div class="ml-10">
              <label :for="`date_prev_from_${rand}`">{{ i18nJS.date_prev_label }} {{ i18nJS.from }}</label>
              <datepicker class="input_date input-medium" v-model="filterParams.datePrev.from" :id="`date_prev_from_${rand}`" />
            </div>
            <div class="ml-10">
              <label :for="`date_prev_to_${rand}`">{{ i18nJS.to }}</label>
              <datepicker class="input_date" v-model="filterParams.datePrev.to" :id="`date_prev_to_${rand}`" />
            </div>
            <div class="ml-10">
              <label :for="`date_eff_from_${rand}`">{{ i18nJS.effdate }} {{ i18nJS.from }}</label>
              <datepicker class="input_date input-medium" v-model="filterParams.dateEff.from" :id="`date_eff_from_${rand}`" />
            </div>
            <div class="ml-10">
              <label :for="`date_eff_to_${rand}`">{{ i18nJS.to }}</label>
              <datepicker class="input_date" v-model="filterParams.dateEff.to" :id="`date_eff_to_${rand}`" />
            </div>
            <button
              type="button"
              class="fa-light fa-chevron-left pulsante_comando js-tooltip bg-white outline-none"
              title=""
              data-original-title="Nascondi"
              @click="toggleFilter()"
            ></button>
            <button
              type="button"
              class="fa-light fa-magnifying-glass pulsante_comando js-tooltip bg-white outline-none"
              title=""
              data-original-title="Cerca..."
              @click="change()"
            ></button>
          </div>
        </transition>
      </div>
    </div>

    <generic-table
      :headerLabels="headerLabels"
      :elements="getTableElements"
      :options="options"
      :lengthPage="lengthPage"
      :elementsDisabled="elementsDisabled"
      @openUrlEvent="openUrl"
      @showUrlEvent="showUrl"
      @printEvent="printEvent"
      @removeElementEvent="removeItem"
    ></generic-table>

    <guest-activity-plan-form
      v-for="(guest_exam, index) in guestExamsWithId"
      :key="index"
      :modal_id="`gap_modal_${guest_exam.id}`"
      :fix_model_type="`${guest_exam.class_name}`"
      :fix_model_id="guest_exam.id || ''"
      :ref_activity="0"
      :only_new_plan="false"
      :grid_create="false"
      :is_single="true"
      :is_planned="true"
      :gbu_id="guest_exam.guest_business_unit_id"
      :guest_full_name="`${guest_exam.guest_full_name}`"
      :business_unit_id="guest_exam.business_unit_id"
      :connected_plans="[guest_exam.connected_plans]"
      :connected_with_grid="guest_exam.connected_with_grid"
      :already_connect="guest_exam.already_connect"
      override_description=""
    />
  </div>
</template>
<script>
import vSelect2 from '../vSelect2';
import genericTable from '../genericTable/genericTable';
import { getCookie } from '../../plugins/userUtils';
import { RandomNumber } from '§/mixin/commonMixins.js';
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../datepicker';
import { GenericTablePrintButton } from '../models/genericTableButtons/printButton';
import guestActivityPlanForm from '../guestActivityPlan/guestActivityPlanForm';

export default {
  name: 'guestExams',
  props: ['guestPeriodDataSetId', 'type', 'pushEnabled', 'prePeriodId', 'externalOeRetrieveDocumentsEnabled'],
  components: {
    vSelect2,
    genericTable,
    guestActivityPlanForm,
    datepicker,
  },
  mixins: [RandomNumber],
  data() {
    return {
      elementsDisabled: [],
      itemSelected: null,
      itemQta: 0,
      isMobile: false,
      headerLabels: i18nJS.guest_exams.table_headers,
      tableElements: [],
      itemExams: [],
      removedElements: [],
      page: 0,
      lengthPage: 20,
      windowWidth: window.innerWidth,
      search: 4,
      todo: 2,
      options: {
        actionColumnEnabled: true,
        canDeleteRow: true,
        htmlContent: true,
        canOpenUrl: true,
        canShowUrl: true,
        infiniteScrollEnable: true,
        handleUpdate: this.handleUpdate,
        isResettableInfiniteLoader: false,
        smallButtons: true,
        onlyIdForCustomButton: true,
        canOpenAttr: 'can_edit',
        canDeleteAttr: 'can_destroy',
        canShowAttr: 'can_show',
        metaAttributes: ['id', 'can_show', 'report_ids', 'can_edit', 'can_destroy'],
        actionButtons: [new GenericTablePrintButton('fa-light fa-print link_print_ricetta', 'id')],
        theadSticky: true,
      },
      activitiesConfigId: null,
      showFilter: false,
      filterParams: {
        datePrev: {
          from: null,
          to: null,
        },
        dateEff: {
          from: null,
          to: null,
        },
        cod: [],
      },
    };
  },
  computed: {
    getExamTypes() {
      return `/${window.locale}/exams/${this.$props.type}.json?view=vselect`;
    },
    guestExamsWithId() {
      return this.tableElements.filter((e) => e.id);
    },
    i18nJS() {
      return window.i18nJS;
    },
    route() {
      return `/${window.locale}/guest_period_data_sets/${this.guestPeriodDataSetId}/guest_exams/${this.$props.type}.json?view=vue`;
    },
    getGuestExamDocumentMethod() {
      return this.externalOeRetrieveDocumentsEnabled ? 'get_guest_exam_document_by_external_oe' : 'get_guest_exam_document_by_h2o';
    },
    getTableElements() {
      return this.tableElements.map(
        // [{name, qta, umd, ....}] -> [{name, qta, umd}]
        ({
          id,
          can_edit,
          can_destroy,
          can_show,
          report_ids,
          business_unit_id,
          class_name,
          confirm_to_diary,
          date_ric,
          datetimeprev,
          description,
          diary_already_sent,
          documents_count,
          documents_link,
          epa_status_ico,
          epa_status,
          epa_service,
          status,
          status_desc,
          status_ico,
          to_diary_link,
          already_connect,
          connected_plans,
          war,
          updated_who_fn,
          updated_who_av,
          updated_at,
          permissions,
          medical_record_open,
          state,
          labels_url,
          refertation_date,
        }) => {
          war = war ? '<i class="fa-light fa-triangle-exclamation red"></i>' : '';
          let cstatus =
            this.pushEnabled && epa_status_ico
              ? '<div style="white-space: nowrap;"><i class="fa-light ' + epa_status_ico + '"></i> '
              : '<div style="white-space: nowrap;">';
          cstatus += this.pushEnabled && epa_service ? '(' + epa_service + ') ' : '';
          cstatus += this.pushEnabled && epa_status ? epa_status + '<br/></div>' : '</div>';
          cstatus += '<i class="fa-light ' + status_ico + '"></i> ' + status_desc + '<br/>';
          if (datetimeprev) {
            datetimeprev = datetimeprev.split(' ')[0] + ' <span style="font-size: 14px">' + datetimeprev.split(' ')[1] + '</span>';
          }

          if (refertation_date) {
            refertation_date =
              refertation_date.split(' ')[0] + ' <span style="font-size: 14px">' + refertation_date.split(' ')[1] + '</span>';
          }

          let refertation_url = `/${window.locale}/guest_period_data_sets/${this.$attrs.guestperioddatasetid || this.guestPeriodDataSetId}/guest_exams/${this.$props.type}`;
          let show_refertation_button = false;
          let refertation_btn = '';
          if (id) {
            const add_report_id_url = report_ids && report_ids.length ? `?report_ids=${report_ids}` : '';
            const refertation_url_ending =
              permissions && permissions.includes('edit') ? `/edit${add_report_id_url}#refertation` : `${add_report_id_url}#refertation`;
            refertation_url += `/${id}${refertation_url_ending}`;
            refertation_btn =
              `<a href="${refertation_url}">` +
              `<span class="fa-light fa-clipboard-list pulsante_comando small js-tooltip" title="${i18nJS.guest_exams.refertation}"></span>` +
              (report_ids && report_ids.length > 0
                ? `<span class="badge badge-notify js-tooltip" title="${i18nJS.guest_exams.external_doc_available}" style="font-size: 10px; background: rgba(218, 99, 4); position: relative; top: -12px; left: -16px">${report_ids.length}</span>`
                : '') +
              `</a>`;
            if (epa_service === 'gipo' && status === 'report') {
              refertation_btn += `<span class="badge badge-notify js-tooltip" title="${i18nJS.guest_exams.external_doc_available}" style="font-size: 10px; background: rgba(218, 99, 4); position: relative; top: -12px; left: -16px">1</span>`;
            }
          } else if (report_ids) {
            let i = 1;
            for (let report_id of report_ids) {
              if (report_id != null && report_id != '') {
                let ref_url = `/${window.locale}/guest_period_data_sets/${this.$attrs.guestperioddatasetid || this.guestPeriodDataSetId}/guest_exams/${this.$props.type}/${this.getGuestExamDocumentMethod}?report_id=${report_id}`;
                refertation_btn +=
                  `<a href="${ref_url}">` +
                  `<span class="fa-light fa-clipboard-list pulsante_comando small js-tooltip" title="${i18nJS.guest_exams.refertation} (${i})"></span>` +
                  `<span class="badge badge-notify js-tooltip" title="${i18nJS.guest_exams.external_doc_available}" style="font-size: 10px; background: rgba(218, 99, 4); position: relative; top: -12px; left: -16px">1</span>`;
                +`</a>`;
                i = i + 1;
              }
            }
          }
          let plan_connected = already_connect
            ? `<span class="badge badge-notify js-tooltip" title="" style="font-size: 10px; background: rgba(218, 99, 4); position: relative; top: -12px; left: -16px">1</span>`
            : ``;
          let plan_btn =
            medical_record_open && id
              ? `<a data-toggle="modal" data-target="#gap_modal_${id}">` +
                `<span class="fa-light fa-clock pulsante_comando small js-open-planning-modal"></span>` +
                plan_connected +
                `</a>`
              : '';

          let labels_btn =
            labels_url && id
              ? `<a target="_blank" href="${labels_url}"><span class="fa-light fa-tags pulsante_comando small js-tooltip" title="${i18nJS.guest_exams.print_exam_labels}"></span></a>`
              : '';

          let plan_btns = refertation_btn + plan_btn + labels_btn;
          let updated_who = updated_at
            ? '</div><user-media :fullname="\'' +
              updated_who_fn +
              '\'" :img="\'' +
              (this.isMobile ? null : updated_who_av) +
              '\'" :datetime="\'' +
              updated_at +
              '\'"/>'
            : null;
          let documents_btn = '<div style="white-space: nowrap;">';
          if (to_diary_link && id) {
            let confirmElement = confirm_to_diary ? ` confirm="${diary_already_sent}"` : '';
            documents_btn +=
              '<a id="link-to-diary-' +
              id +
              '" data-remote="true" href="' +
              to_diary_link +
              '"' +
              confirmElement +
              '><span class="fa-light fa-paper-plane pulsante_comando small js-tooltip" title="" data-original-title="Invia a diario"></span></a></a>';
          }
          if (id) {
            documents_btn +=
              '<a data-remote="true" class="allegati-grid" href="' +
              documents_link +
              '"><span class="fa-light fa-paperclip small js-tooltip pulsante_comando" style="height: 16px; width: 16px;" title="' +
              i18nJS.command.allegati +
              '"/>';
          }
          if (documents_count > 0) {
            documents_btn += '<span class="badge badge-info theme-bg documents_count">' + documents_count + '</span>';
          }
          documents_btn += '</a></div>';
          return {
            id,
            can_edit,
            can_destroy,
            can_show,
            report_ids,
            documents_btn,
            plan_btns,
            date_ric,
            datetimeprev,
            ...(this.search == this.todo ? {} : { refertation_date }),
            description,
            cstatus,
            war,
            updated_who,
          };
        },
      );
    },
  },
  mounted() {
    this.headerLabelsCopy = [...this.headerLabels];
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  methods: {
    showSignModal() {
      this.$refs.digitalSignatureModal.openPopupSignature();
    },
    printEvent(selection) {
      const id = selection.id;
      const element = this.tableElements.filter((e) => e.id === id);
      if (element && element.length > 0 && element[0].can_show) {
        const params = {
          guestBusinessUnitIdData: element[0].guest_business_unit_id.toString(),
          isSignableData: element[0].is_signable && element[0].avoid_print_frontend_sign,
          examIdData: id,
        };

        eventBus.$emit('openRicettaModal', params);
      }
    },
    handleUpdate(callback) {
      return this.getGuestExamsList();
    },
    ldaElement(element) {
      return this.prePeriodId === element.guest_period_data_set_id;
    },
    retrieveTableElements(data) {
      let te = this.tableElements;
      let toInsert = data.filter((el) => !te.find((ap) => ap.id === el.id));
      toInsert.forEach((element) => {
        this.tableElements.push(element);
        if (this.ldaElement(element)) {
          this.elementsDisabled.push(element.id);
        }
        // this.tableElements = this.tableElements.concat(data);
        setTimeout(() => {
          window.updateVueInstances(null, '#table-guest-exams td:last-of-type');
        }, 400);
      });
      this.options.isResettableInfiniteLoader = true;
      return toInsert.length;
    },
    getGuestExamsList() {
      this.page += 1;
      return apiConnector()
        .get(this.route, {
          params: {
            per_page: this.lengthPage,
            page: this.page,
            search: this.search,
            datetimeprev_gteq: this.filterParams.datePrev.from,
            datetimeprev_lteq: this.filterParams.datePrev.to,
            start_gteq: this.filterParams.dateEff.from,
            start_lteq: this.filterParams.dateEff.to,
            exam_id_in: this.filterParams.id,
          },
        })
        .then(({ data }) => {
          try {
            return this.retrieveTableElements(data);
          } catch (err) {
            return 0;
          }
        })
        .catch((err) => {
          return 0;
        });
    },
    openUrl(item, index) {
      const ge = this.tableElements[index];
      if (ge.id) {
        let url = `${window.config.ePersonamService.ePersonamHost}/${window.locale}/guest_period_data_sets/${this.$attrs.guestperioddatasetid || this.guestPeriodDataSetId}/guest_exams/${this.$props.type}/${ge.id}/edit`;
        if (ge.report_ids && ge.report_ids.length) {
          url += `?report_ids=${ge.report_ids}`;
        }
        Loader.show();
        window.open(url, '_self');
      } else {
        console.log('GuestExam without id!', ge);
      }
    },
    showUrl(item, index) {
      const ge = this.tableElements[index];
      if (ge.id) {
        let url = `${window.config.ePersonamService.ePersonamHost}/${window.locale}/guest_period_data_sets/${this.$attrs.guestperioddatasetid || this.guestPeriodDataSetId}/guest_exams/${this.$props.type}/${ge.id}`;
        if (ge.report_ids && ge.report_ids.length) {
          url += `?report_ids=${ge.report_ids}`;
        }
        Loader.show();
        window.open(url, '_self');
      } else {
        console.log('GuestExam without id!', ge);
      }
    },
    selectItem(item) {
      this.udmSelected = null;
      this.itemSelected = JSON.parse(item);
    },
    removeItem(item, index) {
      var tableElements = this.tableElements;
      Loader.show();
      if (window.confirm('Vuoi veramente cancellare questo esame?')) {
        const deleteUrl = this.route.replace(/(^.*\/guest_exams\/\d)(.*)/, '$1/' + tableElements[index].id + '.json');
        console.log(tableElements[index].id, deleteUrl);
        apiConnector()
          .delete(deleteUrl, {})
          .then((result) => {
            if (result.data.success !== false) {
              tableElements.splice(index, 1);
            } else {
              Utils.appendToFlash('error', 'Azione non riuscita');
            }
          })
          .catch((err) => Utils.appendToFlash('error', 'Azione non riuscita'))
          .finally(() => Loader.hide());
      } else {
        Loader.hide();
      }
    },
    change() {
      this.tableElements.splice(0, this.tableElements.length);
      if (this.search == this.todo) {
        this.headerLabels.splice(4, 1);
      } else if (this.search != this.todo) {
        this.headerLabels = [...this.headerLabelsCopy];
      }
      this.page = 0;
      this.options.isResettableInfiniteLoader = !this.options.isResettableInfiniteLoader;
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    getItemExams() {
      if (this.itemExams.length === 0) {
        apiConnector()
          .get(`/${window.locale}/exams/${this.$props.type}.json`, {
            params: {
              per_page: 20,
              page: 1,
            },
          })
          .then(({ data }) => {
            data.forEach((ele) => {
              this.itemExams.push([ele.cod, ele.description]);
            });
          })
          .catch((error) => {
            console.error('getItemExams', error);
          });
      }
      return this.itemExams;
    },
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler(val) {
        this.isMobile = val <= 1000;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
select {
  height: 34px;
}

.text-right {
  text-align: right;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.display-inline-flex {
  display: inline-flex;

  > select,
  label,
  input,
  button {
    margin-bottom: auto;
    margin-top: auto;
  }
}

.ml-20 {
  margin-left: 20px;
}

.leading-35 {
  line-height: 35px;
}

.menu-translate-enter,
.menu-translate-leave-to {
  transform: translatex(-100%);
  opacity: 0;
}

.menu-translate-enter-active {
  transition: all 0.5s ease-out;
}

.menu-translate-leave-active {
  transition: all 0.2s ease-out;
}

.menu-translate-enter-to,
.menu-translate-leave {
  transform: translatex(0%);
  opacity: 1;
}

.bg-white {
  background: white;
}

.z-index-1 {
  z-index: 1;
}

label[for^='dat'] {
  margin-right: 1em;
  text-transform: lowercase;

  &::first-letter {
    text-transform: uppercase;
  }
}

label[for$='_to'] {
  margin-left: 1em;
}

.outline-none {
  outline: none;
}
</style>
